import esriConfig from "@arcgis/core/config.js";

// ArcGIS log levels, from most to least verbose: "info" | "warn" | "error" | "none".
// A level shows its own messages and everything more severe. When unset, ArcGIS uses "warn".
export function setupArcgisLogging() {
    esriConfig.log.level = window.VUE_APP_ENV === "production" ? "error" : "warn";
}
